import React from 'react'
import TooltipField from 'hoc/TooltipField'
import GridLinkCell from 'pages/CustomerMaster/components/GridLinkCell'

export const BranchTooltipCell = props => (<GridLinkCell {...props} />)

export default TooltipField({
  anchorToGridCellText: true,
  indexSearchType: 'branch',
  position: 'right-end',
  recordNameKey: 'value',
  sensitivity: 100,
  type: 'indexSearch'
})(BranchTooltipCell)
